module.exports = __webpack_public_path__ + "img/anquan-active.57c634e2.svg";